/**
 * Joins class names together, filtering out any undefined values
 */
export default function classNames(...classNames: (string | undefined)[]) {
  return classNames.filter(Boolean).join(' ');
}
